import { connect } from 'react-redux';
import { ApplicationRootState } from 'types';
import CategoryNavMobileComponent from '../components/CategoryNavMobile';
import { selectNavMain } from './MainLayout/selectors';

const mapStateToProps = (state: ApplicationRootState) => ({ main: selectNavMain(state) });

const CategoryNavMobile = connect(mapStateToProps)(CategoryNavMobileComponent);

export default CategoryNavMobile;
